/**
 * Currency symbol helper.
 */
export function getCurrencySymbol(currency: string = 'USD'): string {
  const code = (currency || 'USD').toUpperCase().trim();
  if (code === 'EUR') return '€';
  if (code === 'GBP') return '£';
  if (code === 'VES') return 'Bs.';
  return '$';
}

/**
 * Format an amount in Bolivares.
 * @param amount - amount in original currency
 * @param rate - BCV rate (original currency per 1 Bs)
 * @param recargo - percentage surcharge (0-100)
 */
export function convertToBs(amount: number, rate: number, recargo: number = 0): number {
  if (!rate || rate <= 0) return 0;
  const base = amount * rate;
  return recargo > 0 ? base * (1 + recargo / 100) : base;
}

/**
 * Format currency amount with configured symbol.
 * Example: formatCurrency(25.5, 'EUR') -> '€25.50'
 */
export function formatCurrency(
  amount: number,
  currency: string = 'USD'
): string {
  const sym = getCurrencySymbol(currency);
  const num = Number(amount) || 0;
  return `${sym}${num.toFixed(2)}`;
}

/**
 * Format Bolivares amount.
 */
export function formatBs(amount: number): string {
  const num = Number(amount) || 0;
  const [intPart, decPart] = num.toFixed(2).split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `Bs. ${formattedInt},${decPart}`;
}

/**
 * Detect currency code from provider data.
 */
export function detectCurrency(currencyCode?: string): string {
  if (!currencyCode) return 'USD';
  const code = currencyCode.toUpperCase();
  if (['USD', 'EUR', 'GBP', 'AUD', 'CAD', 'COP', 'BRL', 'MXN', 'ARS', 'CLP', 'PEN'].includes(code)) return code;
  return 'USD';
}

/**
 * Extract rate value from Fresha rate response (handles multiple field names).
 */
export function extractRate(rateData: Record<string, unknown>): number {
  const candidates = ['promedio', 'average', 'valor', 'value', 'rate', 'venta'];
  for (const key of candidates) {
    const val = rateData[key];
    if (typeof val === 'number' && val > 0) return val;
  }
  return 0;
}
